import { useConfig } from '~/composables/storyblok-proxy/useConfig';
import z from 'zod';

export const useLoginModal = () => {
    const { data: story } = useConfig();
    useStoryblokBridgeRef(story);

    return computed(() => {
        const modalContent = story.value?.content?.loginModalContent?.[0];

        if (!modalContent || !z.uuid().safeParse(modalContent).success) return null;

        return {
            headline: story.value?.content.loginModalHeadline || null,
            contentUuid: modalContent
        };
    });
};
